// extracted by css-extract-rspack-plugin
export default {"hoverDescriptionContainer":"ProceduresListForMember__hoverDescriptionContainer--Qfxp7","tr":"ProceduresListForMember__tr--dJK9T"};